/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

const kHexRegExp = /^[0-9A-Fa-f]+$/;

export function isHexString(data, options = {}) {
  const { len, pair } = options;
  let regExp = kHexRegExp;
  if (len > 0) {
    regExp = new RegExp(`^[0-9A-Fa-f]{${len}}$`);
  }

  let valid = regExp.test(data.replace(/[:-]/g, ''));
  if (pair) {
    valid = valid && (data.length % 2 === 0);
  }
  return valid;
}

export function isInteger(data, options = {}) {
  const { min, max } = options;
  const num = Number(data);
  if (!_.isInteger(num)) {
    return false;
  }

  if (min && num < min) {
    return false;
  }
  if (max && num > max) {
    return false;
  }

  return true;
}

export function isNumber(data, options = {}) {
  const {
    min,
    max,
    points,
  } = options;
  if (!/^[0-9]+(\.[0-9]+)?$/.test(String(data))) {
    return false;
  }

  if (!_.isNil(points)) {
    const { min: minPoints = 0, max: maxPoints = 64 } = points;
    let regex = new RegExp(`^[0-9]+(\.[0-9]{${minPoints},${maxPoints}})?$`);
    if (minPoints > 0) {
      regex = new RegExp(`^[0-9]+\.[0-9]{${minPoints},${maxPoints}}$`);
    }
    if (!regex.test(String(data))) {
      return false;
    }
  }

  const num = Number(data);
  if (!_.isNumber(num)) {
    return false;
  }

  if (min && num < min) {
    return false;
  }
  if (max && num > max) {
    return false;
  }

  return true;
}




// WEBPACK FOOTER //
// ./src/utils/checkers/numbers.js